export default "__VITE_ASSET__DkUyoCpq__"